import { Paper, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import { AppFormikCheckboxGroup } from 'shared/components/AppComponents';

interface RiskManagementFormProps {
  test: any;
}

const RiskManagementForm: React.FC<RiskManagementFormProps> = () => {
  const rmfDomainRef = useRef<HTMLDivElement | null>(null);
  const { errors, submitCount } = useFormikContext<any>();
  useEffect(() => {
    if (submitCount === 0) return;
    if (!errors || Object.keys(errors).length === 0) return;

    if (Object.keys(errors || {}).includes('ai_rmf_domains')) {
      rmfDomainRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, submitCount]);

  return (
    <Paper variant="outlined" className="risk-management-wrapper">
      <Typography variant="h6" ref={rmfDomainRef}>
        AI risk management framework (RMF) domains *
      </Typography>
      <AppFormikCheckboxGroup
        name="ai_rmf_domains"
        outerLabel=""
        options={[
          { label: 'Transparency', value: 'transparency' },
          { label: 'Fairness', value: 'fairness' },
          { label: 'Accountability', value: 'accountability' },
          { label: 'Robustness', value: 'robustness' },
          { label: 'Safety', value: 'safety' },
          { label: 'Privacy/Security', value: 'privacy/security' },
        ]}
        row
      />
    </Paper>
  );
};

export default RiskManagementForm;
